export default function generateSearchForm(player) {
    const localize = player.localize?.bind(player);
    const template = `<h2 id="mediasite-player__search-header">${localize('Search Slides and Closed Captions')}</h2>
<form>
    <p class="search-box-holder">
        <input type="search" required aria-labelledby="mediasite-player__search-header" placeholder="${localize('Search')}..."
        aria-label="${localize("Search this presentation's slides and closed caption text")}"/>
        <button class="search-button" aria-label="${localize('Search')} value="${localize('Search')}">
            <svg viewBox="0 0 1024 1024"><path class="path1" d="M848.471 928l-263.059-263.059c-48.941 36.706-110.118 55.059-177.412 55.059-171.294 0-312-140.706-312-312s140.706-312 312-312c171.294 0 312 140.706 312 312 0 67.294-24.471 128.471-55.059 177.412l263.059 263.059-79.529 79.529zM189.623 408.078c0 121.364 97.091 218.455 218.455 218.455s218.455-97.091 218.455-218.455c0-121.364-103.159-218.455-218.455-218.455-121.364 0-218.455 97.091-218.455 218.455z"></path></svg>
        </button>
    </p>
    <p class="mediasite-player__search-notice"></p>
</form>`;

    const container = document.createElement('div');
    container.innerHTML = template;
    return container;
}
